import { Link } from "react-router-dom";

export default function Button(props) {
    return (
        <div className="flex justify-end">
            <Link to={props.link} className={`text-[13px] ${props.backgroundColor} px-2 py-1 text-white rounded-[5px] tracking-wide `}>{props.value}</Link>
        </div>
    )
}
